import React from 'react'
import MarkerClusterGroup from 'react-leaflet-cluster';
import L from 'leaflet'

const CustomClusterIcon = ({ children }) => {
    const createClusterCustomIcon = function (cluster) {
        return L.divIcon({
            html: `<div class='arr-bottom flex justify-center items-center bg-brand-primary-500 rounded-xl px-7 py-2 text-base text-white'>${cluster._childCount}</div>`,
            className: 'custom-marker-cluster flex w-16 h-16 text-5xl',
            iconSize: L.point(33, 33, true),
        })
    }

    return (
        <MarkerClusterGroup
            iconCreateFunction={createClusterCustomIcon}
            maxClusterRadius={80}
            spiderfyOnMaxZoom={true}
            showCoverageOnHover={true}
            polygonOptions={{ stroke: true, color: '#ed6608' }}
        >
            {children}
        </MarkerClusterGroup>
    )
}

export default CustomClusterIcon
